import { useInCreateDialog } from 'components/create-dialog/CreateDialogContext';
import { CREATE_DIALOG_FIELDS_CLASS, CREATE_DIALOG_HEADING_PROPS } from 'components/create-dialog/CreateDialogSection';
import { Separator } from 'components/ui/separator';
import { Tooltip } from 'components/ui/tooltip';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getIdLink } from 'utils/linkUtil';
import { SECTION_FIELDS_CLASS } from './Section';

export type SubSectionProps = {
    title: string;
    tooltip?: string;
    noTranslation?: boolean;
    children: React.ReactNode;
};

/**
 * A titled run of fields inside a section. In the create dialog it lays them on the dialog's field grid, and its
 * heading goes when every field under it is in the Required section.
 */
function SubSection({ title, tooltip, noTranslation = false, children }: SubSectionProps) {
    const inCreateDialog = useInCreateDialog();
    const heading = (
        <div
            id={getIdLink(noTranslation ? title.toLocaleLowerCase() : title)}
            data-section-title={title}
            {...(noTranslation ? { 'data-no-translation': noTranslation } : {})}
            className="my-[9px] scroll-mt-24 text-sm leading-6 font-semibold"
        >
            {noTranslation ? title : <FormattedMessage id={title} />}
        </div>
    );

    return (
        <>
            <div {...(inCreateDialog ? CREATE_DIALOG_HEADING_PROPS : undefined)}>
                {tooltip ? <Tooltip content={tooltip}>{heading}</Tooltip> : heading}
                <Separator className="mb-2" />
            </div>
            <div className={inCreateDialog ? CREATE_DIALOG_FIELDS_CLASS : SECTION_FIELDS_CLASS}>{children}</div>
        </>
    );
}

SubSection.displayName = 'SubSection';

export default SubSection;
